module.exports = __webpack_public_path__ + "img/cinema.6e17fbf8.svg";